import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const EyeSlashIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M5.20539 5.5C2.48517 7.27719 1 10 1 10C1 10 4.27273 16 10 16C11.732 16 13.2396 15.4513 14.5 14.6857M17.1343 12.5C18.3542 11.184 19 10 19 10C19 10 15.7273 4 10 4C9.47952 4 8.97932 4.04955 8.5 4.13965"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.71813 8.00007C7.2709 8.51264 7 9.18305 7 9.91673C7 11.5276 8.30584 12.8334 9.91667 12.8334C10.6002 12.8334 11.2288 12.5983 11.726 12.2045M13 9.00007C12.7297 8.18291 11.7942 7.31792 11 7"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="4.06066"
                y1="3"
                x2="17"
                y2="15.9393"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </SvgIcon>
    );
};
